import { Fragment } from 'react';

import { Navigate } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';
import { LocaleContext } from '../../context/LocaleContext';

import { NavBarView } from '../../components/navBar/navBarGuest/navBaGuest';

import { Footer } from '../../ui/footer';

export const Layout = ({ children }) => {
	const { isAuth } = useAuth();

	if (isAuth) return <Navigate to='/overview' />;

	return (
		<LocaleContext.Consumer>
			{() => (
				<Fragment>
					<NavBarView />
					<main>{children}</main>
					<Footer />
				</Fragment>
			)}
		</LocaleContext.Consumer>
	);
};
